module.exports = __webpack_public_path__ + "static/media/Blue-P.ce08c51f.png";